import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { SiSololearn } from "react-icons/si";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    // <Footern>
      <Container fluid className="footer">
        <Container>
          <Row>  
            <Col md="5" className="footer-copywright">
              <h3>Designed & Developed By Attique</h3>
            </Col>

            <Col md="2" className="footer-copywright">
              <h3>Copyright © {year} AR</h3>
            </Col>

            <Col md="5" className="footer-body">
              <ul className="footer-icons">
                <li className="social-icons">
                  <a href="https://github.com/malikar1" style={{ color: "#2b7bd3" }} target="_blank" rel="noopener noreferrer">
                    <AiFillGithub />
                  </a>
                </li>
                <li className="social-icons">
                  <a href="https://twitter.com/malikar111" style={{ color: "#2b7bd3" }} target="_blank" rel="noopener noreferrer">
                    <AiOutlineTwitter />
                  </a>
                </li>
                <li className="social-icons">
                  <a href="https://www.linkedin.com/in/malikar1/" style={{ color: "#2b7bd3" }} target="_blank" rel="noopener noreferrer">
                    <FaLinkedinIn />
                  </a>
                </li>
                <li className="social-icons">
                  <a href="https://www.instagram.com/u.ar98" style={{ color: "#2b7bd3" }} target="_blank" rel="noopener noreferrer">
                    <AiFillInstagram />
                  </a>
                </li>
                <li className="social-icons">
                  <a href="https://www.sololearn.com/profile/24453847" style={{ color: "#2b7bd3" }} target="_blank" rel="noopener noreferrer">
                    <SiSololearn />
                  </a>
                </li>
              </ul>
            </Col>

          </Row>
        </Container>
      </Container>
    // </Footer>
  );
}

export default Footer;
